import React from 'react';
import {Invoice} from './TorqueInvoiceSearch';

type OrderHeaderProps = {
    invoice: Invoice
}

export const OrderHeader: React.FunctionComponent<OrderHeaderProps> = ({
                                                                           invoice
                                                                       }): JSX.Element => {
    return (
        <>
            <div className="col-5 offset-1">
                <div>
                    <strong>Sales Order#</strong>
                    <span className="pl-2">{invoice.salesOrderNumber}</span>
                </div>
                <div>
                    <strong>Invoice#</strong>
                    <span className="pl-2">{invoice.invoiceNumber}</span>
                </div>
                <div>
                    <strong>Customer PO#</strong>
                    <span className="pl-2">{invoice.customerPoNumber}</span>
                </div>
            </div>
            <div className="col-5">
                <div className="pl-2">
                    <div><strong>Bill To Customer</strong></div>
                    <div>{invoice.customerName}</div>
                    <div>
                        {[
                            invoice.customerCity && invoice.customerCity,
                            invoice.customerCity && invoice.customerState && ', ',
                            invoice.customerState && invoice.customerState,
                            invoice.customerPostalCode
                        ].filter(Boolean).join(' ')}
                    </div>
                </div>
            </div>
        </>
    );
}